var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13,
  _t14,
  _t15,
  _t16,
  _t17,
  _t18,
  _t19,
  _t20,
  _t21,
  _t22,
  _t23,
  _t24,
  _t25,
  _t26,
  _t27,
  _t28,
  _t29,
  _t30,
  _t31,
  _t32,
  _t33,
  _t34,
  _t35,
  _t36,
  _t37,
  _t38,
  _t39,
  _t40,
  _t41,
  _t42,
  _t43,
  _t44,
  _t45,
  _t46,
  _t47,
  _t48,
  _t49;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import translations from '../../common/sport/translations';
import css from './style.pcss';
import PlaceholderLogo from "../../common/images/logo_placeholder.svg";
var RTLSportTable = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLSportTable, _LitElement);
  function RTLSportTable() {
    var _this;
    _classCallCheck(this, RTLSportTable);
    _this = _callSuper(this, RTLSportTable);
    _this.language = 'lu';
    _this.view = 'default';
    _this.teamId = '';
    _this.type = 'large';
    _this.hlslug = '';
    if (window.rtlsites) {
      _this.language = window.rtlsites.config.language;
      _this.version = window.rtlsites.config.version;
      _this.assetsUrl = window.rtlsites.config.assetsUrl;
    }
    return _this;
  }
  _createClass(RTLSportTable, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLSportTable.prototype), "connectedCallback", this).call(this);
      this._fetchCompetitions();
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      if (!this.sport && !this.competition) return;
      var apiUrl = `https://api-gate.rtl.lu/sport/sports/${this.sport}/competitions/${this.competition}/ranking?lang=${this.language}`;
      fetch(apiUrl).then(function (resp) {
        if (resp.ok) {
          return resp.json();
        } else {
          throw new Error("404 Response");
        }
      }).then(function (resp) {
        _this2.data = resp;
        _this2.view = 'default';
      });
    }
  }, {
    key: "_fetchCompetitions",
    value: function _fetchCompetitions() {
      var _this3 = this;
      // Competitions
      var compAPI = `https://api-gate.rtl.lu/sport/sports/${this.sport}/competitions?lang=${this.language}`;
      fetch(compAPI).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this3.competitions = resp;
        var currentComp;
        if (_this3.competition == 0) {
          currentComp = _this3.competitions.filter(function (comp) {
            if (comp.priority === true) {
              return true;
            }
            return false;
          });
        } else {
          currentComp = _this3.competitions.filter(function (comp) {
            if (comp.id === _this3.competition) {
              return true;
            }
            return false;
          });
        }
        if (currentComp.length == 1) {
          _this3.competition = currentComp[0].id;
          _this3.competitionName = currentComp[0].name;
        }
        _this3._fetchData();
      });
    }
  }, {
    key: "_getTranslation",
    value: function _getTranslation(key) {
      if (!translations[key]) {
        //console.warn(key + ' is not defined in translations.js!');
      } else return translations[key][this.language];
    }
  }, {
    key: "_renderTeam",
    value: function _renderTeam() {
      var _this4 = this;
      return html(_t || (_t = _`
            <div align="left" class="sport-table__back" @click=${0}}>&laquo; ${0}</div>
            <rtl-sport-team id="${0}"></rtl-sport-table>
        `), function (e) {
        return _this4._fetchData();
      }, this._getTranslation('back'), this.teamId);
    }
  }, {
    key: "_showTeam",
    value: function _showTeam(teamId) {
      this.teamId = teamId;
      this.view = 'team';
    }
  }, {
    key: "_showLink",
    value: function _showLink(e, link) {
      document.location.href = `${link}`;
      return;
    }
  }, {
    key: "_renderFootball",
    value: function _renderFootball() {
      var _this5 = this;
      var standings = this.data.ranking;
      return html(_t2 || (_t2 = _`
            <table class="default-table sport-table__table">
                <tr class="sport__tr-header">
                    <th class="sport-table__th sport-table__th--rankcode"></th>
                    <th class="sport-table__th"></th>
                    <th class="sport-table__th sport-table__th--team" align="left">${0}</th>
                    <th class="sport-table__th">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th mhide">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th mhide">${0}</th>
                </tr>
                ${0}
            </table>
        `), this._getTranslation('team'), this._getTranslation('games-short'), this._getTranslation('games'), this._getTranslation('won-short'), this._getTranslation('won'), this._getTranslation('draws-short'), this._getTranslation('draws'), this._getTranslation('lost-short'), this._getTranslation('lost'), this._getTranslation('points-short'), this._getTranslation('points'), this._getTranslation('diff-short'), this._getTranslation('diff'), this._getTranslation('form'), standings.map(function (standing, i) {
        return html(_t3 || (_t3 = _`
                    <tr class="sport-table__tr">
                        <td class="sport-table__td sport-table__td--rankcode rankcode${0}${0}${0}">
                            <span class="tooltip">${0}</span>
                        </td>
                        <td class="sport-table__td sport-table__td--rank">${0}</td>
                        ${0}
                        <td class="sport-table__td sport-table__td--matches">${0}</td>
                        <td class="sport-table__td sport-table__td--wins">${0}</td>
                        <td class="sport-table__td sport-table__td--draws">${0}</td>
                        <td class="sport-table__td sport-table__td--losses">${0}</td>
                        <td class="sport-table__td sport-table__td--points">${0}</td>
                        <td class="sport-table__td sport-table__td--td mhide">${0}-${0}</td>
                        <td class="sport-table__td sport-table__td--form mhide">
                            <div class="sport-table__form-container">
                            ${0}
                            </div>
                        </td>
                    </tr>
                `), _this5.sport, _this5.competition, i, _this5._getTranslation(`rankcode${_this5.sport}${_this5.competition}${i}`), standing.position > 0 ? standing.position : '', standing.team._links ? html(_t4 || (_t4 = _`
                            <td class="sport-table__td sport-table__td--team" @click=${0}>
                                ${0}
                                ${0}
                            </td>
                        `), function (e) {
          return _this5._showLink(e, '/sport' + _this5.hlslug + '/teams?c=' + _this5.competition + '&t=' + standing.team.id);
        }, standing.team.logo_url ? html(_t5 || (_t5 = _`<img class="sport-table__img" src="${0}?v=${0}" />`), standing.team.logo_url, _this5.version) : html(_t6 || (_t6 = _`<img class="sport-table__img" src="${0}" />`), PlaceholderLogo), standing.team.name) : html(_t7 || (_t7 = _`
                            <td class="sport-table__td sport-table__td--team">
                                ${0}
                                ${0}
                            </td>
                        `), standing.team.logo_url ? html(_t8 || (_t8 = _`<img class="sport-table__img" src="${0}?v=${0}" />`), standing.team.logo_url, _this5.version) : html(_t9 || (_t9 = _`<img class="sport-table__img" src="${0}" />`), PlaceholderLogo), standing.team.name), standing.matches, standing.wins, standing.draws, standing.losses, standing.points, standing.home_score, standing.visitor_score, standing.form.slice(0, 5).map(function (match, i) {
          return html(_t10 || (_t10 = _`
                                <div class="sport-table__form sport-table__form--${0} sport-table__form--m${0}">${0}</div>
                            `), match, i, _this5._getTranslation(match));
        }));
      }));
    }
  }, {
    key: "_renderBasketball",
    value: function _renderBasketball() {
      var _this6 = this;
      var standings = this.data.ranking;
      return html(_t11 || (_t11 = _`
            <table class="default-table sport-table__table">
                <tr class="sport__tr-header">
                    <th class="sport-table__th sport-table__th--rankcode"></th>
                    <th class="sport-table__th"></th>
                    <th class="sport-table__th sport-table__th--team" align="left">${0}</th>
                    <th class="sport-table__th">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th sport-table__th--spacer mhide"></th>
                    <th class="sport-table__th mhide">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th mhide">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th mhide">${0}</th>
                </tr>
                ${0}
            </table>
        `), this._getTranslation('team'), this._getTranslation('games-short'), this._getTranslation('games'), this._getTranslation('won-short'), this._getTranslation('won'), this._getTranslation('lost-short'), this._getTranslation('lost'), this._getTranslation('points-short'), this._getTranslation('points'), this._getTranslation('off-short'), this._getTranslation('off'), this._getTranslation('def-short'), this._getTranslation('def'), this._getTranslation('form'), standings.map(function (standing, i) {
        return html(_t12 || (_t12 = _`
                    <tr class="sport-table__tr">
                        <td class="sport-table__td sport-table__td--rankcode rankcode${0}${0}${0}">
                            <span class="tooltip">${0}</span>
                        </td>
                        <td class="sport-table__td" align="center">${0}</td>
                        ${0}
                        <td class="sport-table__td sport-table__td--matches">${0}</td>
                        <td class="sport-table__td sport-table__td--wins">${0}</td>
                        <td class="sport-table__td sport-table__td--losses">${0}</td>
                        <td class="sport-table__td sport-table__td--points">${0}</td>
                        <td class="sport-table__td sport-table__td--spacer mhide"></td>
                        <td class="sport-table__td sport-table__td--off mhide">${0}</td>
                        <td class="sport-table__td sport-table__td--deff mhide">${0}</td>
                        <td class="sport-table__td sport-table__td--form mhide">
                            <div class="sport-table__form-container">
                                ${0}
                            </div>
                        </td>
                    </tr>
                `), _this6.sport, _this6.competition, i, _this6._getTranslation(`rankcode${_this6.sport}${_this6.competition}${i}`), standing.position > 0 ? standing.position : '', standing.team._links ? html(_t13 || (_t13 = _`
                            <td class="sport-table__td sport-table__td--team" style="cursor: pointer" @click=${0}>
                                ${0}
                                ${0}
                            </td>
                        `), function (e) {
          return _this6._showLink(e, '/sport' + _this6.hlslug + '/teams?c=' + _this6.competition + '&t=' + standing.team.id);
        }, standing.team.logo_url ? html(_t14 || (_t14 = _`<img class="sport-table__img" src="${0}?v=${0}" />`), standing.team.logo_url, _this6.version) : html(_t15 || (_t15 = _`<img class="sport-table__img" src="${0}" />`), PlaceholderLogo), standing.team.name) : html(_t16 || (_t16 = _`
                            <td class="sport-table__td sport-table__td--team" >
                                ${0}
                                ${0}
                            </td>
                        `), standing.team.logo_url ? html(_t17 || (_t17 = _`<img class="sport-table__img" src="${0}?v=${0}" />`), standing.team.logo_url, _this6.version) : html(_t18 || (_t18 = _`<img class="sport-table__img" src="${0}" />`), PlaceholderLogo), standing.team.name), standing.matches, standing.wins, standing.losses, standing.points, standing.home_score, standing.visitor_score, standing.form.slice(0, 5).map(function (match, i) {
          return html(_t19 || (_t19 = _`
                                    <div class="sport-table__form sport-table__form--${0} sport-table__form--m${0}">${0}</div>
                                `), match, i, _this6._getTranslation(match));
        }));
      }));
    }
  }, {
    key: "_renderHandball",
    value: function _renderHandball() {
      var _this7 = this;
      var standings = this.data.ranking;
      return html(_t20 || (_t20 = _`
            <table class="default-table sport-table__table">
                <tr class="sport__tr-header">
                    <th class="sport-table__th sport-table__th--rankcode"></th>
                    <th class="sport-table__th"></th>
                    <th class="sport-table__th sport-table__th--team" align="left">${0}</th>
                    <th class="sport-table__th">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th mhide">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th mhide">${0}</th>
                </tr>
                ${0}
            </table>
        `), this._getTranslation('team'), this._getTranslation('games-short'), this._getTranslation('games'), this._getTranslation('won-short'), this._getTranslation('won'), this._getTranslation('draws-short'), this._getTranslation('draws'), this._getTranslation('lost-short'), this._getTranslation('lost'), this._getTranslation('points-short'), this._getTranslation('points'), this._getTranslation('diff-short'), this._getTranslation('diff'), this._getTranslation('form'), standings.map(function (standing, i) {
        return html(_t21 || (_t21 = _`
                    <tr class="sport-table__tr">
                        <td class="sport-table__td sport-table__td--rankcode rankcode${0}${0}${0}">
                            <span class="tooltip">${0}</span>
                        </td>
                        <td class="sport-table__td" align="center">${0}</td>
                        ${0}
                        <td class="sport-table__td sport-table__td--matches">${0}</td>
                        <td class="sport-table__td sport-table__td--wins">${0}</td>
                        <td class="sport-table__td sport-table__td--draws">${0}</td>
                        <td class="sport-table__td sport-table__td--losses">${0}</td>
                        <td class="sport-table__td sport-table__td--points">${0}</td>
                        <td class="sport-table__td sport-table__td--td mhide">${0}-${0}</td>
                        <td class="sport-table__td sport-table__td--form mhide">
                            <div class="sport-table__form-container">
                                ${0}
                            </div>
                        </td>
                    </tr>
                `), _this7.sport, _this7.competition, i, _this7._getTranslation(`rankcode${_this7.sport}${_this7.competition}${i}`), standing.position > 0 ? standing.position : '', standing.team._links ? html(_t22 || (_t22 = _`
                            <td class="sport-table__td sport-table__td--team" style="cursor: pointer" @click=${0}>
                                ${0}
                                ${0}
                            </td>
                        `), function (e) {
          return _this7._showLink(e, '/sport' + _this7.hlslug + '/teams?c=' + _this7.competition + '&t=' + standing.team.id);
        }, standing.team.logo_url ? html(_t23 || (_t23 = _`<img class="sport-table__img" src="${0}?v=${0}" />`), standing.team.logo_url, _this7.version) : html(_t24 || (_t24 = _`<img class="sport-table__img" src="${0}" />`), PlaceholderLogo), standing.team.name) : html(_t25 || (_t25 = _`
                            <td class="sport-table__td sport-table__td--team" >
                                ${0}
                                ${0}
                            </td>
                        `), standing.team.logo_url ? html(_t26 || (_t26 = _`<img class="sport-table__img" src="${0}?v=${0}" />`), standing.team.logo_url, _this7.version) : html(_t27 || (_t27 = _`<img class="sport-table__img" src="${0}" />`), PlaceholderLogo), standing.team.name), standing.matches, standing.wins, standing.draws, standing.losses, standing.points, standing.home_score, standing.visitor_score, standing.form.slice(0, 5).map(function (match, i) {
          return html(_t28 || (_t28 = _`
                                    <div class="sport-table__form sport-table__form--${0} sport-table__form--m${0}">${0}</div>
                                `), match, i, _this7._getTranslation(match));
        }));
      }));
    }
  }, {
    key: "_renderVolleyball",
    value: function _renderVolleyball() {
      var _this8 = this;
      var standings = this.data.ranking;
      return html(_t29 || (_t29 = _`
            <table class="default-table sport-table__table">
                <tr class="sport__tr-header">
                    <th class="sport-table__th sport-table__th--rankcode"></th>
                    <th class="sport-table__th"></th>
                    <th class="sport-table__th sport-table__th--team" align="left">${0}</th>
                    <th class="sport-table__th">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th sport-table__th--spacer mhide"></th>
                    <th class="sport-table__th mhide">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th mhide">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th mhide">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th mhide">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th mhide">${0}</th>
                </tr>
                ${0}
            </table>
        `), this._getTranslation('team'), this._getTranslation('games-short'), this._getTranslation('games'), this._getTranslation('won-short'), this._getTranslation('won'), this._getTranslation('lost-short'), this._getTranslation('lost'), this._getTranslation('points-short'), this._getTranslation('points'), this._getTranslation('setswon-short'), this._getTranslation('setswon'), this._getTranslation('setslost-short'), this._getTranslation('setslost'), this._getTranslation('pointswon-short'), this._getTranslation('pointswon'), this._getTranslation('pointslost-short'), this._getTranslation('pointslost'), this._getTranslation('form'), standings.map(function (standing, i) {
        return html(_t30 || (_t30 = _`
                    <tr class="sport-table__tr">
                        <td class="sport-table__td sport-table__td--rankcode rankcode${0}${0}${0}">
                            <span class="tooltip">${0}</span>
                        </td>
                        <td class="sport-table__td">${0}</td>
                        ${0}
                        <td class="sport-table__td sport-table__td--matches">${0}</td>
                        <td class="sport-table__td sport-table__td--wins">${0}</td>
                        <td class="sport-table__td sport-table__td--losses">${0}</td>
                        <td class="sport-table__td sport-table__td--points">${0}</td>
                        <td class="sport-table__td sport-table__td--spacer mhide"></td>
                        <td class="sport-table__td sport-table__td--score mhide">${0}</td>
                        <td class="sport-table__td sport-table__td--score mhide">${0}</td>
                        <td class="sport-table__td sport-table__td--score mhide">${0}</td>
                        <td class="sport-table__td sport-table__td--score mhide">${0}</td>
                        <td class="sport-table__td sport-table__td--form mhide">
                            <div class="sport-table__form-container">
                                ${0}
                            </div>
                        </td>
                    </tr>
                `), _this8.sport, _this8.competition, i, _this8._getTranslation(`rankcode${_this8.sport}${_this8.competition}${i}`), standing.position > 0 ? standing.position : '', standing.team._links ? html(_t31 || (_t31 = _`
                            <td class="sport-table__td sport-table__td--team" style="cursor: pointer" @click=${0}>
                                ${0}
                                ${0}
                            </td>
                        `), function (e) {
          return _this8._showLink(e, '/sport' + _this8.hlslug + '/teams?c=' + _this8.competition + '&t=' + standing.team.id);
        }, standing.team.logo_url ? html(_t32 || (_t32 = _`<img class="sport-table__img" src="${0}?v=${0}" />`), standing.team.logo_url, _this8.version) : html(_t33 || (_t33 = _`<img class="sport-table__img" src="${0}" />`), PlaceholderLogo), standing.team.name) : html(_t34 || (_t34 = _`
                            <td class="sport-table__td sport-table__td--team" >
                                ${0}
                                ${0}
                            </td>
                        `), standing.team.logo_url ? html(_t35 || (_t35 = _`<img class="sport-table__img" src="${0}?v=${0}" />`), standing.team.logo_url, _this8.version) : html(_t36 || (_t36 = _`<img class="sport-table__img" src="${0}" />`), PlaceholderLogo), standing.team.name), standing.matches, standing.wins, standing.losses, standing.points, standing.home_score, standing.visitor_score, standing.home_set_score, standing.visitor_set_score, standing.form.slice(0, 5).map(function (match, i) {
          return html(_t37 || (_t37 = _`
                                    <div class="sport-table__form sport-table__form--${0} sport-table__form--m${0}">${0}</div>
                                `), match, i, _this8._getTranslation(match));
        }));
      }));
    }
  }, {
    key: "_renderDeschtennis",
    value: function _renderDeschtennis() {
      var _this9 = this;
      var standings = this.data.ranking;
      return html(_t38 || (_t38 = _`
            <table class="default-table sport-table__table">
                <tr class="sport__tr-header">
                    <th class="sport-table__th sport-table__th--rankcode"></th>
                    <th class="sport-table__th"></th>
                    <th class="sport-table__th sport-table__th--team" align="left">${0}</th>
                    <th class="sport-table__th">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th">
                        ${0}
                        <span class="tooltip">${0}</span>
                    </th>
                    <th class="sport-table__th mhide">${0}</th>
                </tr>
                ${0}
            </table>
        `), this._getTranslation('team'), this._getTranslation('games-short'), this._getTranslation('games'), this._getTranslation('won-short'), this._getTranslation('won'), this._getTranslation('draws-short'), this._getTranslation('draws'), this._getTranslation('lost-short'), this._getTranslation('lost'), this._getTranslation('points-short'), this._getTranslation('points'), this._getTranslation('form'), standings.map(function (standing, i) {
        return html(_t39 || (_t39 = _`
                    <tr class="sport-table__tr">
                        <td class="sport-table__td sport-table__td--rankcode rankcode${0}${0}${0}">
                            <span class="tooltip">${0}</span>
                        </td>
                        <td class="sport-table__td">${0}</td>
                        ${0}
                        <td class="sport-table__td sport-table__td--matches">${0}</td>
                        <td class="sport-table__td sport-table__td--wins">${0}</td>
                        <td class="sport-table__td sport-table__td--draws">${0}</td>
                        <td class="sport-table__td sport-table__td--losses">${0}</td>
                        <td class="sport-table__td sport-table__td--points">${0}</td>
                        <td class="sport-table__td sport-table__td--form mhide">
                            <div class="sport-table__form-container">
                                ${0}
                            </div>
                        </td>
                    </tr>
                `), _this9.sport, _this9.competition, i, _this9._getTranslation(`rankcode${_this9.sport}${_this9.competition}${i}`), standing.position > 0 ? standing.position : '', standing.team._links ? html(_t40 || (_t40 = _`
                            <td class="sport-table__td sport-table__td--team" style="cursor: pointer" @click=${0}>
                                ${0}
                                ${0}
                            </td>
                        `), function (e) {
          return _this9._showLink(e, '/sport' + _this9.hlslug + '/teams?c=' + _this9.competition + '&t=' + standing.team.id);
        }, standing.team.logo_url ? html(_t41 || (_t41 = _`<img class="sport-table__img" src="${0}?v=${0}" />`), standing.team.logo_url, _this9.version) : html(_t42 || (_t42 = _`<img class="sport-table__img" src="${0}" />`), PlaceholderLogo), standing.team.name) : html(_t43 || (_t43 = _`
                            <td class="sport-table__td sport-table__td--team" >
                                ${0}
                                ${0}
                            </td>
                        `), standing.team.logo_url ? html(_t44 || (_t44 = _`<img class="sport-table__img" src="${0}?v=${0}" />`), standing.team.logo_url, _this9.version) : html(_t45 || (_t45 = _`<img class="sport-table__img" src="${0}" />`), PlaceholderLogo), standing.team.name), standing.matches, standing.wins, standing.draws, standing.losses, standing.points, standing.form.slice(0, 5).map(function (match, i) {
          return html(_t46 || (_t46 = _`
                                    <div class="sport-table__form sport-table__form--${0} sport-table__form--m${0}">${0}</div>
                                `), match, i, _this9._getTranslation(match));
        }));
      }));
    }
  }, {
    key: "_renderDefault",
    value: function _renderDefault() {
      var _this10 = this;
      if (this.data.ranking == null) return;
      var output;

      // 1: Football / 2: Basketball / 3: Handball / 4: Volleyball / 5: Deschtennis
      var sportSlug;
      switch (this.sport) {
        case 1:
          sportSlug = "futtball";
          output = this._renderFootball();
          break;
        case 2:
          sportSlug = "basketball";
          output = this._renderBasketball();
          break;
        case 3:
          sportSlug = "handball";
          output = this._renderHandball();
          break;
        case 4:
          sportSlug = "volleyball";
          output = this._renderVolleyball();
          break;
        case 5:
          sportSlug = "deschtennis";
          output = this._renderDeschtennis();
          break;
      }
      this.hlslug = '/resultats';
      if (this.language == 'en') this.hlslug = '/results';
      if (this.language == 'lu') this.hlslug = '/' + sportSlug + '/resultater';
      return html(_t47 || (_t47 = _`
            <div class="sport-table">
                ${0}
                ${0}
            </div>
        `), output, this.type == 'small' ? html(_t48 || (_t48 = _`<a @click=${0} class="sport-table__more">${0} &raquo;<a>`), function (e) {
        return _this10._showLink(e, '/sport' + _this10.hlslug + '/national?c=' + _this10.competition);
      }, this._getTranslation('results_link')) : ``);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.data === undefined) return null;
      return html(_t49 || (_t49 = _`
            <style>${0}</style>

            ${0}
        `), css, this.view == 'default' ? this._renderDefault() : this._renderTeam());
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        sport: {
          type: Number
        },
        // 1: Football / 2: Basketball / 3: Handball / 4: Volleyball / 5: Deschtennis
        competition: {
          type: Number
        },
        language: {
          type: String
        },
        view: {
          type: String
        },
        type: {
          type: String
        },
        version: {
          type: String
        }
      };
    }
  }]);
  return RTLSportTable;
}(LitElement);
export { RTLSportTable as default };
window.customElements.define('rtl-sport-table', RTLSportTable);